export default {"src":"/_next/static/media/team-member-bg.99515394.svg","height":135,"width":242};